namespace Matrix.Data {
    export interface MarketExchangeRow {
        Mic?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        CountryName?: string;
        CountryCode?: string;
        OperatingMic?: string;
        OS?: string;
        Name?: string;
        Acronym?: string;
        City?: string;
        Website?: string;
        StatusDate?: string;
        Status?: string;
        CreationDate?: string;
        Comments?: string;
    }

    export namespace MarketExchangeRow {
        export const idProperty = 'Mic';
        export const nameProperty = 'Mic';
        export const localTextPrefix = 'Data.MarketExchange';
        export const deletePermission = 'DataAdmin:MarketExchange';
        export const insertPermission = 'DataAdmin:MarketExchange';
        export const readPermission = 'Read:MarketExchange';
        export const updatePermission = 'DataAdmin:MarketExchange';

        export declare const enum Fields {
            Mic = "Mic",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            CountryName = "CountryName",
            CountryCode = "CountryCode",
            OperatingMic = "OperatingMic",
            OS = "OS",
            Name = "Name",
            Acronym = "Acronym",
            City = "City",
            Website = "Website",
            StatusDate = "StatusDate",
            Status = "Status",
            CreationDate = "CreationDate",
            Comments = "Comments"
        }
    }
}
